/** Portal do Cliente (Onda 1): textos do app "Malgo" em português (namespace `portal`). */
export const portalPt = {
  app: { nome: 'Malgo', subtitulo: 'Portal do cliente', carregando: 'Carregando o portal', titulo: 'Sua empresa e a Malgo, no mesmo lugar.', texto: 'Faturas, documentos e conversa com a equipe, no celular ou no computador.' },
  faixa: { sandbox: 'Sandbox: ambiente de teste', verComo: 'Visualização da equipe da Malgo: só leitura, registrada na auditoria' },
  menu: { hoje: 'Hoje', saida: 'Seu acesso', financeiro: 'Financeiro', relatorios: 'Relatórios', documentos: 'Documentos', mensagens: 'Mensagens', perfil: 'Perfil', empresas: 'Trocar de empresa', sair: 'Sair', principal: 'Navegação do portal', conta: 'Conta e empresa' },
  entrar: {
    passkey: 'Entrar com passkey (Face ID, digital)',
    passkeyErro: 'Passkey não reconhecida. Entre com o código do e-mail.',
    titulo: 'Entrar no portal',
    texto: 'Digite o seu e-mail. Mandamos um código e um link de entrada, sem precisar de senha.',
    email: 'E-mail',
    pedir: 'Receber código',
    enviado: 'Se o e-mail tiver acesso ao portal, o código chega em instantes. Confira também a caixa de spam.',
    codigo: 'Código de 6 dígitos',
    confirmar: 'Entrar',
    reenviar: 'Mandar outro código',
    trocarEmail: 'Usar outro e-mail',
    comSenha: 'Entrar com senha',
    semSenha: 'Entrar com código por e-mail',
    senha: 'Senha',
    lembrar: 'Lembrar este aparelho por 30 dias',
    codigoInvalido: 'Código incorreto ou vencido. Confira o e-mail mais recente ou peça outro.',
    credenciais: 'E-mail ou senha incorretos.',
    bloqueado: 'Muitas tentativas. Espere alguns minutos e tente de novo.',
    linkTitulo: 'Entrar com o link do e-mail',
    linkTexto: 'Toque no botão para entrar. O link vale uma vez só, neste aparelho.',
    linkEntrar: 'Entrar',
    linkOutroAparelho: 'Este link só vale no aparelho em que você pediu. Digite o código de 6 dígitos que veio no mesmo e-mail.',
    linkInvalido: 'Link inválido, usado ou vencido. Peça um novo código.',
    golpe: 'A Malgo nunca pede senha ou código por mensagem ou telefone.',
  },
  convite: {
    titulo: 'Convite para o portal',
    texto: '{{escritorio}} convidou você para o portal da empresa {{empresa}}.',
    termo: 'Termo de uso',
    aceito: 'Li e aceito o termo de uso',
    entrar: 'Aceitar e entrar',
    invalido: 'Convite inválido, já usado ou vencido. Peça um novo convite à Malgo.',
    termoObrigatorio: 'Para entrar, aceite o termo de uso.',
  },
  verComo: { titulo: 'Abrindo a visualização da equipe', invalido: 'Link de visualização inválido ou vencido. Gere outro na ficha do cliente.' },
  termo: { titulo: 'Termo de uso atualizado', texto: 'O termo de uso do portal mudou. Leia e aceite para continuar.', aceitar: 'Li e aceito', versao: 'Versão {{versao}}' },
  saida: {
    titulo: 'Acesso de saída',
    texto: 'O último contrato com o escritório foi encerrado. Até {{data}} você ainda pode consultar os documentos e o histórico financeiro e baixar os seus dados para levar a outro escritório.',
    depois: 'Depois dessa data o acesso ao portal é encerrado.',
    baixar: 'Baixar meus dados',
    baixarTexto: 'Um arquivo com as faturas, as assinaturas e a lista dos documentos. Os arquivos de cada documento baixam em Documentos.',
    documentos: 'Ver documentos',
    financeiro: 'Ver histórico financeiro',
    baixado: 'Dados baixados',
  },
  hoje: {
    titulo: 'Hoje',
    saudacao: 'Olá, {{nome}}',
    tudoEmDia: 'Tudo em dia.',
    tudoEmDiaTexto: 'Nada depende de você agora. Avisamos quando chegar algo novo.',
    fatura: 'Fatura {{numero}}',
    vencida: 'Vencida em {{data}}',
    vence: 'Vence em {{data}}',
    pagar: 'Pagar',
    ver: 'Ver',
    entrega: 'Documento novo',
    assinatura: 'Para assinar',
    abrir: 'Abrir',
    mensagem_one: 'Nova resposta da equipe',
    mensagem_other: '{{count}} novas respostas da equipe',
    responder: 'Responder',
    lista: 'O que depende de você',
  },
  financeiro: {
    titulo: 'Financeiro',
    abertas: 'Em aberto',
    pagas: 'Pagas nos últimos 12 meses',
    semAbertas: 'Nenhuma fatura em aberto.',
    semPagas: 'Nenhuma fatura paga nos últimos 12 meses.',
    resumo: 'Resumo de {{ano}}',
    faturado: 'Faturado no ano',
    pago: 'Pago no ano',
    aberto: 'Em aberto',
    vencido: 'Vencido',
    estado: { em_aberto: 'Em aberto', parcial: 'Pago em parte', pago: 'Pago', vencida: 'Vencida' },
    vencimento: 'Vencimento',
    emissao: 'Emissão',
    competencia: 'Competência',
    valor: 'Valor',
    saldo: 'Saldo a pagar',
    pagoEm: 'Pago em {{data}}',
    parcela: 'Parcela {{parcela}} de {{parcelas}}',
    pix: 'Pix copia e cola',
    qr: 'QR Code do Pix',
    copiar: 'Copiar código',
    copiado: 'Código copiado',
    boleto: 'Linha digitável do boleto',
    copiarLinha: 'Copiar linha digitável',
    abrirBoleto: 'Abrir boleto',
    abrirFatura: 'Abrir a fatura no Asaas',
    semCobranca: 'A forma de pagamento desta fatura ainda está sendo preparada. Fale com a equipe se precisar pagar agora.',
    outraEmpresaTitulo: 'Fatura de outra empresa',
    outraEmpresa: 'Esta fatura é de uma empresa que a sua conta não acessa neste portal. Entre com o e-mail que recebeu a cobrança, ou fale com a equipe.',
    pagoAgora: 'Pagamento confirmado. Obrigado!',
    voltar: 'Voltar ao financeiro',
    ateAgora: 'Atualiza sozinho quando o pagamento cai.',
    assinaturas: {
      titulo: 'Assinaturas',
      vazio: 'Nenhuma assinatura ativa.',
      pausada: 'Pausada',
      ativa: 'Ativa',
      desde: 'Desde {{data}}',
      ate: 'Até {{data}}',
      proximas: 'Próximas cobranças',
      semProximas: 'Nenhuma cobrança agendada.',
      avulso: 'Cobrança única',
      recorrencia: { mes_one: 'Todo mês', mes_other: 'A cada {{count}} meses', semana_one: 'Toda semana', semana_other: 'A cada {{count}} semanas', dia_one: 'Todo dia', dia_other: 'A cada {{count}} dias' },
      ajuda: 'Para mudar ou cancelar uma assinatura, fale com a equipe em Mensagens.',
    },
  },
  relatorios: {
    titulo: 'Relatórios',
    texto: 'Relatórios que a Malgo preparou para a sua empresa. Cada um abre sempre com os números do momento.',
    vazio: 'A Malgo ainda não publicou relatórios para você.',
    tipo: { posicao: 'Posição financeira', extrato: 'Extrato do período' },
    publicado: 'Publicado em {{data}}',
    voltar: 'Voltar aos relatórios',
    posicaoEm: 'Faturas em aberto em {{data}}',
    emitidasEntre: 'Faturas emitidas de {{de}} a {{ate}}',
    pagasEntre: 'Faturas pagas de {{de}} a {{ate}}',
    totais: 'Totais do relatório',
    documentos: 'Faturas',
    pago: 'Pago',
    pagoEm: 'Pagamento',
    numero: 'Fatura',
    atraso: 'Atraso',
    dias_one: '{{count}} dia',
    dias_other: '{{count}} dias',
    aVencer: 'A vencer',
    situacao: 'Situação',
    tabela: 'Faturas do relatório',
    semFaturas: 'Nenhuma fatura no período.',
    truncado: 'Mostrando as primeiras {{n}} faturas; os totais somam todas.',
    atualizado: 'Atualizado agora: os números são do momento em que você abriu.',
  },
  assinar: {
    aba: 'Para assinar',
    vazio: 'Nenhum documento para você assinar.',
    situacao: { pendente: 'Esperando a sua assinatura', assinado: 'Assinado', recusado: 'Recusado', encerrado: 'Encerrado' },
    versao: 'Versão {{versao}}',
    enviado: 'enviado em {{data}}',
    ate: 'assine até {{data}}',
    ler: 'Ler',
    assinar: 'Assinar',
    recusar: 'Recusar',
    cancelar: 'Cancelar',
    titulo: 'Assinar o documento',
    explicacao: 'Para assinar, confirme com o código que enviamos ao seu e-mail. Ficam registrados a data e a hora, o seu IP, o navegador e o código do arquivo (hash) desta versão.',
    hash: 'Código do arquivo (SHA-256)',
    codigo: 'Código do e-mail',
    codigoAjuda: 'Seis números. Peça um código novo se não chegou.',
    assinado: 'Documento assinado',
    recusarTitulo: 'Recusar a assinatura',
    motivo: 'Motivo',
    motivoAjuda: 'A equipe da Malgo recebe o motivo.',
    recusado: 'Assinatura recusada',
  },
  documentos: {
    titulo: 'Documentos',
    daMalgo: 'Da Malgo',
    enviar: 'Enviar',
    semEntregas: 'A Malgo ainda não publicou documentos para você. Quando publicar, eles aparecem aqui. Se precisar mandar um documento, envie por aqui.',
    enviarAgora: 'Enviar um documento',
    novo: 'Novo',
    baixar: 'Baixar',
    visto: 'Visto em {{data}}',
    publicado: 'Publicado em {{data}}',
    area: { financeiro: 'Financeiro', dp: 'Departamento pessoal', fiscal: 'Fiscal', contabil: 'Contábil', societario: 'Societário', geral: 'Geral' },
    tipo: { extrato: 'Extrato bancário', nota_fiscal: 'Nota fiscal', folha_ponto: 'Folha de ponto', admissao: 'Admissão', comprovante: 'Comprovante', contrato: 'Contrato', outro: 'Outro' },
    enviarTitulo: 'Enviar documento à Malgo',
    enviarTexto: 'Tire uma foto ou escolha o arquivo: PDF, imagem, planilha, documento ou XML de nota, até 25 MB.',
    arquivo: 'Arquivo',
    camera: 'Usar a câmera',
    escolher: 'Escolher arquivo',
    tipoCampo: 'Tipo',
    areaCampo: 'Área',
    competenciaCampo: 'Competência (opcional)',
    descricaoCampo: 'Observação (opcional)',
    mandar: 'Enviar',
    enviado: 'Documento enviado. A equipe foi avisada.',
    enviados: 'Enviados pela sua empresa',
    semEnviados: 'Nada enviado ainda.',
    recebido: 'Recebido pela Malgo',
    aguardando: 'Aguardando a Malgo',
    meu: 'Enviado por você',
  },
  mensagens: {
    titulo: 'Mensagens',
    texto: 'Converse com a equipe da Malgo. A resposta chega aqui e no seu celular.',
    vazia: 'Nenhuma mensagem ainda. Escreva a primeira.',
    escrever: 'Escreva a sua mensagem',
    enviar: 'Enviar',
    equipe: 'Equipe Malgo',
    voce: 'Você',
    estado: { pendente: 'Enviando', entregue: 'Entregue', lida: 'Lida', falhou: 'Não enviada' },
    anexar: 'Anexar arquivo',
    anexarAjuda: 'PDF, imagem, planilha, documento ou XML de nota, até 25 MB',
    removerAnexo: 'Tirar o arquivo {{nome}}',
    baixarAnexo: 'Baixar {{nome}}',
    indisponivel: 'As mensagens pelo portal ainda não estão ligadas no seu escritório.',
  },
  perfil: {
    passkeys: 'Passkey',
    passkeysTexto: 'Entre com o Face ID, a digital ou o Windows Hello deste aparelho, sem código. O código do e-mail continua valendo.',
    cadastrarPasskey: 'Entrar sem senha neste aparelho (passkey)',
    removerPasskey: 'Remover',
    removerPasskeyTexto: 'Para remover a passkey "{{nome}}", confirme que é você.',
    passkeyRemovida: 'Passkey removida.',
    passkeyCadastrada: 'Passkey cadastrada.',
    semPasskey: 'Nenhuma passkey cadastrada.',
    passkeyUsada: 'Último uso: {{data}}',
    titulo: 'Perfil',
    nome: 'Nome',
    salvarNome: 'Salvar',
    idioma: 'Idioma',
    tema: 'Tema',
    temaSistema: 'Do aparelho',
    temaClaro: 'Claro',
    temaEscuro: 'Escuro',
    fonte: 'Tamanho do texto',
    fonteNormal: 'Normal',
    fonteMaior: 'Maior',
    fonteGrande: 'Grande',
    fonteMuitoGrande: 'Muito grande',
    simples: 'Modo simples',
    simplesAjuda: 'Esconde Relatórios e a troca de empresas do menu. Você ainda abre tudo por link.',
    simplesDesligado: 'Desligado',
    simplesLigado: 'Ligado',
    avisos: 'Avisos no aparelho',
    avisosTexto: 'Receba no celular quando houver fatura nova, documento ou resposta da equipe. O aviso não mostra valores nem nomes.',
    ativarAvisos: 'Ativar avisos',
    avisosAtivos: 'Avisos ativos neste aparelho',
    desativarAvisos: 'Desativar neste aparelho',
    avisosNegados: 'Os avisos foram bloqueados no navegador. Libere nas configurações do aparelho.',
    avisosIos: 'No iPhone e no iPad, instale o app: toque em Compartilhar e depois em "Adicionar à Tela de Início".',
    avisosSemSuporte: 'Este navegador não recebe avisos.',
    seguranca: 'Segurança',
    senha: 'Senha (opcional)',
    senhaTexto: 'Você entra pelo código do e-mail. Se preferir, defina uma senha.',
    senhaAtual: 'Senha atual',
    confirmacaoTexto: 'Para mudar a senha, cadastrar ou remover uma passkey ou anonimizar a conta, confirme que é você: digite a senha atual ou o código que enviamos ao seu e-mail.',
    codigoEmail: 'Código do e-mail',
    enviarCodigo: 'Enviar código ao e-mail',
    codigoEnviado: 'Enviamos um código ao seu e-mail. Ele vale por 10 minutos.',
    confirmarPasskey: 'Confirme que é você',
    senhaNova: 'Nova senha (mínimo 10 caracteres)',
    salvarSenha: 'Salvar senha',
    removerSenha: 'Remover senha',
    senhaSalva: 'Senha salva. As outras sessões foram encerradas.',
    sairTodos: 'Sair de todos os outros aparelhos',
    sairTodosFeito_one: '{{count}} sessão encerrada',
    sairTodosFeito_other: '{{count}} sessões encerradas',
    dados: 'Seus dados',
    dadosTexto: 'Baixe tudo o que o portal guarda sobre a sua conta, ou anonimize a conta (você sai de todas as empresas).',
    exportar: 'Baixar meus dados',
    anonimizar: 'Apagar meus dados pessoais (anonimizar)',
    anonimizarTitulo: 'Apagar meus dados pessoais (anonimizar)',
    anonimizarTexto: 'O seu nome e e-mail saem do portal e você perde o acesso a todas as empresas. Os documentos que a empresa enviou continuam com ela. Para confirmar, digite o seu e-mail e confirme que é você com a senha atual ou o código do e-mail.',
    confirmacao: 'Seu e-mail',
    termo: 'Termo de uso aceito: versão {{versao}} em {{data}}',
    empresa: 'Empresa',
    papel: 'Seu papel',
  },
  // U15 F1: a ajuda de cada tela. Os nomes de botões e abas vêm das chaves da própria tela ($t), para não ficarem diferentes.
  ajuda: {
    botao: 'Ajuda',
    titulo: 'Ajuda: {{tela}}',
    paraQue: 'Para que serve',
    como: 'Como fazer',
    erro: 'Se der errado',
    deNovo: 'Mostrar de novo na próxima visita',
    deNovoFeito: 'Pronto. A ajuda abre de novo na próxima vez que você entrar nesta tela.',
    lerEmVoz: 'Ler em voz alta',
    pararLeitura: 'Parar',
    entendi: 'Entendi',
    hoje: {
      para: 'Aqui fica o que está esperando por você. Se não houver nada, aparece Tudo em dia.',
      passos: [
        'Veja a lista $t(hoje.lista).',
        'Em uma fatura, toque em $t(hoje.pagar).',
        'Em um documento novo ou para assinar, toque em $t(hoje.abrir).',
        'Em uma resposta da equipe, toque em $t(hoje.responder).',
      ],
      erro: 'Se a lista não aparecer ou algo não abrir, avise a equipe que atende você.',
    },
    financeiro: {
      para: 'Aqui você vê as faturas da sua empresa e quanto falta pagar.',
      passos: [
        'Veja as faturas na lista $t(financeiro.abertas).',
        'Toque na fatura que você quer pagar.',
        'Toque em $t(financeiro.copiar) e pague pelo Pix no app do seu banco.',
        'Se preferir boleto, toque em $t(financeiro.copiarLinha) ou em $t(financeiro.abrirBoleto).',
        'Quando o pagamento cair, a fatura sai de $t(financeiro.abertas) sozinha.',
      ],
      erro: 'Se o pagamento não aparecer ou não houver Pix, avise a equipe que atende você.',
    },
    mensagens: {
      para: 'Aqui você conversa com a equipe da Malgo. A resposta chega aqui e no seu celular.',
      passos: [
        'Escreva no campo $t(mensagens.escrever).',
        'Para mandar um arquivo, toque no clipe ($t(mensagens.anexar)).',
        'Toque em $t(mensagens.enviar).',
        'Veja embaixo da mensagem se ela foi entregue ou lida.',
      ],
      erro: 'Se a mensagem ficar como Não enviada, avise a equipe que atende você.',
    },
    documentos: {
      para: 'Aqui estão os documentos que a Malgo publicou para você e os que você envia.',
      passos: [
        'Na aba $t(documentos.daMalgo), toque em $t(documentos.baixar) para guardar um documento.',
        'Se existir a aba $t(assinar.aba), toque em $t(assinar.ler) e depois em $t(assinar.assinar).',
        'Confirme a assinatura com o código que chegou no seu e-mail.',
        'Para mandar, abra a aba $t(documentos.enviar) e toque em $t(documentos.camera) ou $t(documentos.escolher).',
        'Escolha o tipo e a área e toque em $t(documentos.mandar).',
      ],
      erro: 'Se o arquivo falhar ou o código não chegar, avise a equipe que atende você.',
    },
    perfil: {
      para: 'Aqui você cuida da sua conta, dos avisos e da segurança do seu acesso.',
      passos: [
        'Mude o $t(perfil.nome), o $t(perfil.idioma), o $t(perfil.tema) e o $t(perfil.fonte).',
        'Em $t(perfil.avisos), toque em $t(perfil.ativarAvisos) para receber alertas no celular.',
        'Toque em $t(perfil.cadastrarPasskey) e confirme que é você.',
        'Em $t(perfil.dados), toque em $t(perfil.exportar) para receber uma cópia.',
        'Para tirar seu nome e e-mail do portal, toque em $t(perfil.anonimizar).',
      ],
      erro: 'Se a confirmação falhar, peça outro código ou avise a equipe que atende você.',
    },
  },
  papel: { dono: 'Dono', financeiro: 'Financeiro', dp: 'Departamento pessoal', fiscal: 'Fiscal', societario: 'Societário', colaborador: 'Colaborador' },
  empresas: { titulo: 'Suas empresas', texto: 'Escolha a empresa que você quer ver agora.', atual: 'Atual', escolher: 'Ver esta' },
  instalar: { titulo: 'Instale o app Malgo', texto: 'Tenha o portal na tela inicial e receba os avisos.', botao: 'Instalar', depois: 'Agora não' },
  erros: {
    codigos: {
      'portal.passkey_invalida': 'Passkey não reconhecida. Entre com o código do e-mail.',
      'portal.nao_autenticado': 'Sua sessão terminou. Entre de novo.',
      'portal.codigo_invalido': 'Código incorreto ou vencido.',
      'portal.credenciais_invalidas': 'E-mail ou senha incorretos.',
      'portal.bloqueado': 'Muitas tentativas. Espere alguns minutos.',
      'portal.link_outro_aparelho': 'Este link só vale no aparelho em que você pediu. Digite o código do e-mail.',
      'portal.link_invalido': 'Link inválido, usado ou vencido. Peça um novo.',
      'portal.convite_invalido': 'Convite inválido ou vencido.',
      'portal.termo_obrigatorio': 'Aceite o termo de uso para entrar.',
      'portal.termo_pendente': 'Aceite o termo de uso para continuar.',
      'portal.termo_mudou': 'O termo mudou. Leia a versão nova.',
      'portal.somente_leitura': 'Visualização da equipe: só leitura.',
      'portal.nao_encontrado': 'Não encontrado.',
      'portal.area_invalida': 'Área fora do seu acesso.',
      'portal.senha_atual_incorreta': 'Senha atual incorreta.',
      'portal.confirmacao_incorreta': 'Digite o seu e-mail para confirmar.',
      'portal.empresa_nao_encontrada': 'Empresa não encontrada.',
      'arquivo.tipo_nao_permitido': 'Tipo de arquivo não permitido. Envie PDF, imagem, planilha, documento ou XML de nota.',
      'arquivo.muito_grande': 'Arquivo acima de 25 MB.',
      'portal.envio_limite': 'Você chegou ao limite de envios por agora (30 por hora e 300 MB por dia). Tente mais tarde ou fale com a equipe.',
      'portal.confirmacao_obrigatoria': 'Confirme com a senha atual ou com o código que enviamos ao seu e-mail.',
      'portal.mensagem_limite': 'Você chegou ao limite de mensagens por agora (60 por hora). Tente mais tarde.',
      'arquivo.vazio': 'Arquivo vazio.',
      'dispositivo.invalido': 'Não deu para ativar os avisos neste aparelho.',
    },
  },
};

export type TextosPortal = typeof portalPt;
